const editableSelector = 'input, textarea, [contenteditable]:not([contenteditable="false"])';
const textInputTypes = new Set(['text', 'search', 'email', 'url', 'tel']);

function disablePrediction(element) {
  if (element.matches('input') && !textInputTypes.has(element.type)) return;

  Object.entries({
    autocorrect: 'off',
    autocapitalize: 'off',
    autocomplete: 'off',
    spellcheck: 'false',
  }).forEach(([name, value]) => {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  });
}

function applyToTree(node) {
  if (node.nodeType !== Node.ELEMENT_NODE) return;

  if (node.matches(editableSelector)) disablePrediction(node);
  node.querySelectorAll(editableSelector).forEach(disablePrediction);
}

export default function disableTextPrediction() {
  applyToTree(document.body);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach(({ addedNodes, type, target }) => {
      if (type === 'attributes') applyToTree(target);
      addedNodes.forEach(applyToTree);
    });
  });
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['type', 'contenteditable', 'autocomplete', 'autocorrect', 'autocapitalize', 'spellcheck'],
    childList: true,
    subtree: true,
  });

  return () => observer.disconnect();
}
